import React from 'react';

import {Pager} from 'react-bootstrap';

const PagerUd = props => {
  const {languageData, languageCode} = window.myConsts;

  return (
    <Pager style={props.style}>
      <Pager.Item href="#" onSelect={props.onPreviousClick} disabled={props.disablePreviousBtn}>{languageData['450'][languageCode]}</Pager.Item>
      {' '}
      <Pager.Item href="#" onSelect={props.onNextClick} disabled={props.disableNextBtn}>{languageData['451'][languageCode]}</Pager.Item>
    </Pager>
  );
}

PagerUd.propTypes = {
  onPreviousClick: React.PropTypes.func.isRequired,
  onNextClick: React.PropTypes.func.isRequired,
}

export default PagerUd;






// WEBPACK FOOTER //
// ./src/commonComponents/PagerUd.jsx